<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in :title="title"></SectionTitle>
    <div class="content-txt">
      <div class="t-text animate-target" v-animate-in>The RACGP type 2 diabetes handbook advises measurement of UACR and eGFR at least annually to ensure early detection of CKD<sup>1</sup></div>
      <div class="t-desc animate-target" v-animate-in>CKD is largely asymptomatic until advanced CKD occurs. This means early assessment and diagnosis are critical before the severity of disease is advanced.</div>
      <ul class="txt-list">
        <li class="animate-target" v-animate-in>CKD is diagnosed by the persistent presence of:
          <ul>
            <li class="animate-target" v-animate-in>– elevated urine albumin excretion,</li>
            <li class="animate-target" v-animate-in>– low eGFR or</li>
            <li class="animate-target" v-animate-in>– other manifestations of kidney damage</li>
          </ul>
        </li>
        <li class="animate-target" v-animate-in>Screening for CKD can be performed by the following two laboratory tests:
          <ul>
            <li class="animate-target" v-animate-in>– early morning or spot urine UACR</li>
            <li class="animate-target" v-animate-in>– eGFR (automatically calculated from measurement of serum creatinine).</li>
          </ul>
        </li>
      </ul>
      <div class="t-text animate-target" v-animate-in>Any positive UACR needs to be confirmed within 3 months.</div>
    </div>
    <GoNext class="animate-target" v-animate-in href="/section3/">Next</GoNext>
    <ContentNotice  class="animate-target" v-animate-in :txt="noticeTxt"/>
  </div>
</template>

<script>
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
import {mapState} from "vuex";
export default {
  name: "s2-5",
  components: {SectionTitle, GoNext, ContentNotice},
  data(){
    return {
      noticeTxt:"CKD=chronic kidney disease; eGFR, estimated glomerular filtration rate; RACGP, Royal Australian College of General Practitioners; UACR, urine albumin-to-creatinine ratio.<br/><div class='brs'></div>"
      +"Reference:<br/><div class='brs'></div>"
      +"1. RACGP. Management of type 2 diabetes: A handbook for general practice. <a target='_blank' href='https://www.racgp.org.au/getattachment/7c05e922-ab1f-4301-aab7-f4f9b638cb66/Management-of-type-2-diabetes-A-handbook-for-general-practice.aspx' class='c-url'>https://www.racgp.org.au/getattachment/7c05e922-ab1f-4301-aab7-f4f9b638cb66/Management-of-type-2-diabetes-A-handbook-for-general-practice.aspx</a>.",
      title:"The role for regular measurement of UACR and eGFR: Early assessment is critical because CKD is largely asymptomatic until advanced<sup>1</sup>"
    }
  },
  computed:{

  },
  mounted() {

  }
}
</script>

<style scoped>
@import "../../assets/css/section2/s2.css";
</style>
